<template>
    <div class="autocomplete" :class="{open: showList}">
        <input class="form-control" type="text"
            v-model="fieldVal"
            :placeholder="placeholder"
            @input="updateValue"
            @keydown.enter.prevent="hitEnter"
            @keydown.down.prevent="hitDown"
            @keydown.up.prevent="hitUp"
        />
        <ul class="dropdown-menu suggestions" :class="{show: showList}">
            <li v-for="item, n in list" @click.prevent="clickItem(item)" class="dropdown-item" :class="{active: subIsActive(n)}">
                {{item.label}}
            </li>
        </ul>
    </div>
</template>

<script>

    import debounce from 'debounce';

    export default {
        name: "autocomplete-input",
        props:{
            placeholder: {type:String, default:''},
            suggestMethod: {type: String}
        },
        data(){
            return {
                current: -1,
                list: [],
                fieldVal: ''
            }
        },
        computed:{
            showList(){
                return this.list.length>0;
            }
        },
        mounted(){
            this.fieldVal = this.value;
            if(this.$route.params.query) this.fieldVal = this.$route.params.query;
        },
        methods:{
            updateValue: debounce(function(input){

                let fullQ = input.target.value.toString();
                let words = fullQ.split(' ');
                let q     = words.pop();
                let pref  = words.join(' ');


                if(q.length < 2){
                    this.current = -1;
                    this.list = [];
                    return;
                }
                this.$api[this.suggestMethod](q)
                    .then((res) => {
                        let listArr = [];
                        this.current = -1;
                        if(res){
                            listArr = res.data.tags.map((tag)=>{
                                let label = '';
                                if(pref.length>0) label = pref + " ";
                                label+= tag;
                                return new Object({label})
                            });
                        }
                        this.list = listArr;
                    });

            }, 600),
            hitEnter(inputField){
                this.startSearch();
            },
            clickItem(item){
                this.current  = this.list.indexOf(item);
                this.fieldVal = item.label;
                this.startSearch();
            },
            startSearch(){
                if(this.fieldVal.length < 3){
                    this.$bus.$emit('error', 'Please enter at least 3 chars.')
                    return false;
                }
                this.$emit('input', this.fieldVal);
                this.list = [];
            },
            hitDown(){
                if(this.current < this.list.length -1) this.current++;
                this.fieldVal = this.list[this.current].label;
            },
            hitUp(){
                if(this.current > 0) this.current--;
                this.fieldVal = this.list[this.current].label;
            },
            subIsActive(idx){
                return idx===this.current;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .autocomplete
        position: relative
        display: inline-block

    .suggestions
        width: 100%



</style>


// WEBPACK FOOTER //
// src/components/ui/AutocompleteInput.vue